import { FormattedMessage } from 'react-intl'
import BackIcon from '../icons/BackIcon'
import styled from 'styled-components'
import CloseIcon from '../icons/CloseIcon'
import Icon from '../components/Icon'
import React from 'react'
import { allTransitions } from '../transitions/app-transitions'
import { directionalPadding } from './utils'
import { ReactFC } from '../types'
import { Tooltip } from '@material-ui/core'

export interface TitleProps {
    title?: string
    i18nKey?: string
}

export const ToolbarLabelStyled = styled.span`
    padding-right: 0.5em;
    padding-left: 0.5em;
    font-size: 1.25em;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const ToolbarLabel = ({ title, i18nKey }: TitleProps) => {
    if (!i18nKey && !title) {
        return null
    }
    return (
        <ToolbarLabelStyled>
            {title ? <span>{title}</span> : <FormattedMessage id={i18nKey} />}
        </ToolbarLabelStyled>
    )
}

export const BackButton: ReactFC = ({ close, back, label }) => {
    return (
        <Tooltip title="Go back" aria-label="Go back">
            <a onClick={close} data-testid="go-back">
                <Icon icon={back ? BackIcon : BackIcon } label={label} iconName={undefined} hidden={undefined} />
            </a>
        </Tooltip>
    )
}

export const ToolbarContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;
`

export const ToolbarLeftContainer = styled(ToolbarContainer)`
    ${directionalPadding()}
`

export interface ModalToolbarLeftProps {
    className?: string
    back?: false
    title?: string
    titleLabel?: string
    close: any
    children
}

export const ToolbarLeft = (props: ModalToolbarLeftProps) => {
    const { className, back = false, title, titleLabel, children, close } = props
    return (
        <ToolbarLeftContainer className={className}>
            <BackButton close={close} back={back} />
            <ToolbarLabel title={title} i18nKey={titleLabel || title} />
            {children}
        </ToolbarLeftContainer>
    )
}

export const AbsoluteFlexColumn = styled.div.attrs(()=> ({
    id: "AbsoluteFlexColumn"
}))`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`

export const AbsoluteFlexColumnAnimated = styled(AbsoluteFlexColumn)`
  ${allTransitions}
`